jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($("main.blog").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
     * Ajax Posts
     *****************************************************************/
    $(".filter-by-toggle").click(function () {
      $(this).toggleClass("open");
      $(".filters-toggle-contain").slideToggle();

      if ($(this).hasClass("open")) {
        $(this).text("Close");
      } else {
        $(this).text("Filter By");
      }
    });

    var post_type;
    var category;
    // Filter Posts by Category on category button click
    $(".cat-name").on("click", function (e) {
      e.preventDefault();
      loadmore_params.current_page = 1;
      post_type = $(this).parent().attr("data-post_type");
      category = $(this).attr("data-category");

      if ($(".no-mas").length) {
        $(".no-mas").remove();
      }

      $(".cat-name").removeClass("active");
      $(this).addClass("active");

      if (category == "all") {
        category = "all";
      }

      data = {
        action: "filterposts",
        category: category,
        post_type: post_type,
      };

      $.ajax({
        url: loadmore_params.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          $(".load-cats.loading-dots").show();
        },
        success: function (data) {
          $(".loading-dots").hide();
          if (data) {
            $(".blogpost-container").html(data.posts);

            if (!$(".resource-post-section").hasClass("show")) {
              setTimeout(function () {
                $(".resource-post-section, .resource-post-section .fade-in-up").addClass("show");
              }, 225);
            }
          } else {
            $(".blogpost-container").html("No posts found.");
          }
        },
      });
    });

    // Checks the Current Cat in category.php
    if (typeof currentCat !== "undefined") {
      if (!category) {
        category = currentCat;
      }
    }

    // Load more posts on Button Click
    $(".loadmore").click(function (e) {
      e.preventDefault();

      post_type = $(".filter-nav-container .post-filter-nav").attr("data-post_type");

      var button = $(this),
        data = {
          action: "loadmore",
          query: loadmore_params.posts, // that's how we get params from wp_localize_script() function
          page: loadmore_params.current_page,
          category: category,
          post_type: post_type,
        };

      $.ajax({
        // you can also use $.post here
        url: loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          $(".load-more.loading-dots").show();
          button.hide();
        },
        success: function (data) {
          if (data) {
            $(".blogpost-container").append(data);
            loadmore_params.current_page++;
            button.show();

            if (loadmore_params.current_page == loadmore_params.max_page) {
              button.hide(); // if last page, remove the button
            }

            $(".resource-post-section").each(function (index, el) {
              if (!$(el).hasClass("show")) {
                setTimeout(function () {
                  $(el).addClass("show");
                  $(el).find(".fade-in-up").addClass("show");
                }, 225);
              }
            });
          } else {
            button.hide(); // if no data, remove the button as well
            $(".load-more-container").append('<p class="no-mas sub-title">That\'s all folks!</p>');
          }

          $(".load-more.loading-dots").hide();
        },
      });
    });

    $(".cat-name").click(function () {
      $(".loadmore").show();
    });

    /*****************************************************************
      Projects
    ******************************************************************/
    var projectSlider = $(".projects .owl-carousel");
    projectSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        navContainer: ".prop-controls",
        navElement: "div",
        navText: ["", ""],
        items: 1,
        margin: 0,
        slideBy: 1,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        autoHeight: true,
        lazyLoad: true,
        checkVisibility: false,
        responsive: {
          768: {
            items: 3,
          },
          950: {
            items: 3,
          },
          1200: {
            items: 3,
          },
        },
        onInitialized: function (e) {
          var totalCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-total");
          var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
          // totalCount.text("0" + e.item.count);

          var spacerItemsReducer = 2;
          if (isMobile) {
            spacerItemsReducer = 0;
          }

          totalCount.text("0" + (e.item.count - spacerItemsReducer));

          currentCount.text("0" + (e.item.index + 1));
        },
      })
      .on("changed.owl.carousel", function (e) {
        var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
        currentCount.text("0" + (e.item.index + 1));
      });
    $(window).on("resize", function () {
      $(".projects .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }
});
